export const roomDraft: string = `
<h3>部屋のコンセプトは？</h3>
<blockquote><p>部屋の名前の由来や部屋の個性を紹介しましょう。魅力を端的に表す言葉を見出しにしましょう。細かな設備の紹介ではなく、そこの部屋で体験できることがテキストや写真から想像できるようにしましょう。</p></blockquote>

<h3>「山々を望む特等席」</h3>
<p>(例)ミニマルなデザインの中で寛いでいただきたいという想いで、その花言葉から「金木犀」という名をつけました。
<br>光の入り方にこだわりながら、自然に溶け込むようにデザインされた部屋は天井が高く開放感があり、大きな窓からは古山山脈の絶景を望むことができます。</p>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955769205.jpg"></h6>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955786901.jpg">(写真を1-2枚入れましょう)</h6>

<h3>部屋の特徴は？</h3>
<blockquote><p>部屋の特徴を記載しましょう。その特徴によって提供できる体験をを見出しにして、設備の細かな説明ではなく、どんな体験、時間を過ごせるのかを記載すると良い記事になります。</p></blockquote>

<h3>「お湯に癒される」</h3>
<p>(例)部屋付きの半露天風呂の浴槽は無垢材を使用しています。
<br>プライベートな空間に漂う木材の香りを温かなお湯で癒しの時間を過ごしください。</p>
<h6><img src="https://dev-assets.chillnn.com/public/170519fcba3156/imgs/pubimg.1610955573362.jpg">(写真を1-2枚入れましょう)</h6>

<h3><strong>部屋の注意点は？</strong></h3>
<blockquote><p>部屋の利用にあたっての注意事項を記載して、ゲストの不安点を解消しましょう。</p></blockquote>
<p>(例)ご注意事項<br>22時以降は近隣住民の方々に配慮して、静かにお過ごしください</p>`;

export const howToBeautiful: string = `
<h3>１.改行のススメ</h3>
<p>改行は「<strong>Shift + Enter</strong>」、段落を分けたい時は「<strong>Enter</strong>」の使い分けをすると読みやすい記事になります。</p>
<h3>２.引用のススメ</h3>
<blockquote><p>視覚的に目立たせたい段落には「引用」の利用がおすすめです。</p></blockquote>
<h3>３.画像のススメ</h3>
<p>Enter &gt; image、または、ドラッグアンドドロップ、コピーアンドペーストで画像を挿入できます。</p>`;
